
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"16","height":"16","viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M15.12.88A2.89 2.89 0 0013 0H3A2.89 2.89 0 00.88.88 2.89 2.89 0 000 3v10c0 .826.293 1.533.88 2.12A2.89 2.89 0 003 16h10a2.89 2.89 0 002.12-.88A2.89 2.89 0 0016 13V3a2.89 2.89 0 00-.88-2.12zm-1.786 7.453c0 .292-.136.497-.407.615a.725.725 0 01-.26.052.62.62 0 01-.469-.198l-1.5-1.5-5.562 5.563a.642.642 0 01-.47.197.641.641 0 01-.468-.197l-1.062-1.063a.64.64 0 01-.198-.469.64.64 0 01.198-.468l5.562-5.563-1.5-1.5c-.215-.201-.264-.444-.146-.73.118-.27.323-.405.615-.405h5c.18 0 .337.066.469.198a.64.64 0 01.198.468v5z","fill":"currentColor"}})])
          )
        }
      }
    